const translationKeys = {
  betAmount: '베팅 금액',
  maxBetAmountLimit: '최대 베팅 금액 {{value}}을(를) 초과했습니다',
  minBetAmountLimit: '최소 베팅 금액은 {{value}}입니다.',
  noBalance: '베팅 금액이 지갑 잔액을 초과했습니다',
  noAutoCashout: '자동 배당률이 필요합니다.',
  autoRateWarning: '자동 배당률은 일정 기준 이상이어야 합니다',
  autoRateWarningMaxOdds: '자동 배당률은 일정 기준 이하이어야 합니다',
  limit: '한도를 초과했습니다.',
  notAchieved: '달성하지 못했습니다.',
  maxBetAmount: '최대 베팅 금액',
  minBetAmount: '최소 베팅 금액',
  BET: '베팅',
  PLACE_BET: '베팅',
  CASH_OUT_BET: '캐시아웃',
  WAIT: '대기',
  PLACE: '배팅하기',
  CASHOUT_AT: '다음 배당률에서 캐시아웃',
  CANCEL: '취소',
  CANCEL_BET: '취소',
  isRequired: '{{label}} 항목은 필수입니다',
  404: '404',
  pageNotFound: '찾고 있는 페이지를 찾을 수 없습니다!',
  error: '오류',
  somethingWentWrong: '문제가 발생했습니다!',
  announcement_1: '게임 시작까지 남은 시간',
  announcement_2: '다음에서 캐시아웃됨',
  announcement_3: '베팅 마감까지',
  announcement_4: '베팅 접수 중',
  BETS: '베팅 내역',
  HUBERT_TITLE: 'Hubert Hits',
  SOUND: '사운드',
  MUSIC: '음악',
  ANIMATION: '애니메이션',
  GAME_INFO: '게임 정보',
  HOW_TO_PLAY: '게임 방법',
  GAME_RULES: '게임 규칙',
  BET_HISTORY: '내 베팅 기록',
  LEADERBOARD: '리더보드',
  GAME_LIMIT: '게임 한도',
  BALANCE: '잔액',
  WAITING_ROUND: '다음 라운드 대기 중',
  ROUND_ID: '라운드 ID',
  ERROR_MESSAGE: '오류 메시지',
  ERROR_DESC: '세션이 만료되었거나 액세스 토큰이 전달되지 않았습니다',
  GAME_LIMIT_TITLE: '게임 한도',
  MIN_BET: '최소 베팅',
  MAX_BET: '최대 베팅',
  MAX_WIN: '단일 베팅 최대 당첨금',
  NO_DATA: '데이터가 없습니다',
  PLAYER: '플레이어',
  MULTIPLIER: '배당률',
  WIN: '당첨',
  MY_BET: '내 베팅',
  CASHOUT: '캐시아웃',
  DATE: '날짜',
  GAME_INFO_DESC: 'Hubert Hits는 "Crash" 장르의 재미있는 온라인 멀티플레이어 게임입니다. 1.00x에서 시작하는 배당률이 충돌 전까지 무작위로 정해진 값까지 상승합니다. 충돌 전에 출금하면 해당 배당률이 곱해진 금액을 획득할 수 있습니다. 도시의 분주한 거리에서 다가오는 차량을 피하려는 운전사와 함께하세요.',
  RTP: 'RTP',
  GAME_VERSION: '게임 버전',
  HOW_TO_PLAY_DESC_1: '시작하려면 베팅 금액을 선택한 후 베팅 버튼을 클릭하거나 탭하세요. 화면에 베팅 마감 메시지가 나타날 때까지 다음 게임 라운드를 위해 계속해서 베팅하거나 베팅 금액을 변경할 수 있습니다.',
  HOW_TO_PLAY_DESC_2: '현재 라운드의 총 베팅 금액은 총 베팅 창에 표시됩니다. 베팅 시간이 종료되면 배당률이 초기 값인 1.00x로 표시됩니다. 배당률은 처음에는 천천히 증가하다가 점점 더 빠른 속도로 상승합니다. 전체 금액을 한 번에 캐시아웃할 수 있습니다. 캐시아웃하는 시간이 길수록 당첨 금액이 증가하므로, 충돌 전에 꼭 캐시아웃하세요. 게임 라운드는 충돌과 함께 종료되며, 그때까지 캐시아웃하지 않은 금액은 몰수됩니다.',
  HOW_TO_PLAY_DESC_5: '충돌 전에 캐시아웃할 경우, 선택한 베팅 금액에 현재 배당률을 곱한 금액이 당첨 금액이 됩니다. 화면에 나타나는 당첨 알림에는 당신의 당첨 금액이 포함됩니다.',
  GAME_FUNCTIONS: '게임 기능',
  BET_CASHOUT: '베팅 및 캐시아웃',
  HOW_TO_PLAY_DESC_6: '금액을 선택한 후 "베팅" 버튼을 눌러 베팅하세요.',
  HOW_TO_PLAY_DESC_7: '두 번째 베팅을 설정하면 한 라운드에 두 번 베팅할 수 있지만, 두 번째 "베팅" 버튼을 누르기 전까지는 활성화되지 않습니다.',
  HOW_TO_PLAY_DESC_8: '자세한 내용은 ‘캐시아웃’ 섹션을 참고하세요. 캐시아웃을 하면 현재 게임이 종료되고 다음 라운드에서 베팅을 시작할 수 있습니다.',
  RULES_DESC_1: '충돌이 발생할 때마다 배당률은 초기 값인 1.00x에서 무작위로 정해진 배당률까지 상승합니다. {{ value }}x가 충돌 배당률의 최대값입니다.',
  PLACING_BET: '베팅 중',
  RULES_DESC_3: '최소 베팅 금액은 {{value}}입니다 ,',
  RULES_DESC_3_1: '최대 베팅 금액은 {{ value }}입니다 ,',
  RULES_DESC_3_2: '기본 베팅 금액은 {{ value }}이며, 이는 게임 한도 탭에 표시됩니다.',
  GAME_INDICATOR: '게임 정보 표시기',
  RULES_DESC_5: '베팅 기간이 종료된 후 게임에 참여했거나 현재 라운드에서 베팅을 하지 않은 경우, "다음 라운드 대기 중" 메시지가 표시됩니다. 관전자로서 현재 라운드를 지켜보면서 다음 라운드에 베팅할 수 있습니다.',
  RULES_DESC_6: '현재 게임 라운드에 베팅이 접수되면 다음 게임이 표시됩니다.',
  GAME_STARTS: '게임이 3초 후 시작됩니다.',
  RULES_DESC_7: '베팅을 확정하면 모든 베팅 구역이 비활성화되고, 베팅 기간 종료 시 베팅이 마감됩니다.',
  BALANCE_INDICATOR: '잔액 표시기',
  RULES_DESC_8: '잔액 표시기에 사용 가능한 자금과 통화가 표시됩니다. 베팅을 감당할 만큼 잔액이 충분한지 확인하세요. 베팅, 손실 또는 당첨 후에도 잔액이 갱신되지 않으면 게임을 재시작해 주세요.',
  BET_INDICATOR: '총 베팅 표시기',
  RULES_DESC_9: '현재 게임 라운드에 베팅된 총 금액은 총 베팅 표시기에 나타납니다. 각 라운드에는 고유한 RoundID 번호가 부여되며 화면 오른쪽 하단에 표시됩니다. 현재 지역 시간은 시간 표시기에 나타납니다. 예: 12:12',
  RULES_DESC_10: '문의 사항이 있거나 고객 서비스에 연락할 경우 Round ID 번호를 참고하시거나 라운드 번호 스크린샷을 저장해 주세요.',
  CASHING_OUT: '캐시아웃',
  RULES_DESC_11: '베팅이 승인되면 현재 게임 라운드에 참여할 수 있습니다. 캐시아웃하려면 ‘캐시아웃’ 버튼을 클릭하거나 탭하세요.',
  RULES_DESC_12: 'Hubert Hits는 실시간 게임이므로 인터넷 연결 상태에 따라 “캐시아웃” 처리에 시간이 걸릴 수 있습니다.',
  RULES_DESC_13: '"캐시아웃" 버튼을 누르면 지급 요청이 시작됩니다. 충돌이 발생하지 않은 경우 게임 서버에서 처리 시점의 배당률로 지급이 결정됩니다.',
  RULES_DESC_14: '"캐시아웃"을 선택하면 현재 게임에서 활성화된 모든 베팅의 이익을 출금합니다. 당첨 금액은 배당률이 증가함에 따라 표시되며, 현재 배당률은 버튼에 표시됩니다.',
  RULES_DESC_15: '충돌 전에 이 버튼을 누르면 게임 서버에서 확인 절차가 진행되며, 요청이 승인된 시점의 배당률에 따라 최종 당첨 금액이 확정됩니다.',
  AUTO_CASHOUT: '자동 캐시아웃',
  RULES_DESC_16: '베팅 기간 동안 화면 패널의 토글을 사용해 "자동 캐시아웃"을 활성화하세요.',
  RULES_DESC_18: '참고: 선택한 배당률이 충돌 배당률보다 작거나 같으면 자동 캐시아웃이 해당 배당률로 지급을 보장합니다. 게임 라운드가 시작되면 이 설정을 변경할 수 없지만, "캐시아웃" 버튼을 사용해 더 낮은 값으로 수동 캐시아웃은 가능합니다.',
  RULES_DESC_19: '지정한 게임 라운드 수만큼 자동으로 베팅을 반복하는 자동 플레이 기능을 설정할 수 있습니다.',
  RULES_DESC_20: '베팅하고, 자동 캐시아웃 값을 설정한 후 자동 플레이 버튼을 눌러 자동 플레이 기능을 활성화하세요.',
  RULES_DESC_21: '자동 플레이 창이 뜨면 베팅을 반복할 게임 라운드 수를 선택하세요. 카지노 관할 구역에 따라 추가 설정이 제공될 수 있습니다.',
  RULES_DESC_22: '시작 버튼을 누르면 자동 플레이가 시작됩니다.',
  RULES_DESC_23: '자동 플레이가 작동하는 동안 각 게임 라운드마다 베팅이 자동으로 확정됩니다. 자동 캐시아웃 설정이나 베팅 금액을 변경하려면 베팅을 취소해야 합니다.',
  RULES_DESC_24: '자동 플레이를 중지하려면 자동 플레이 창을 열고 중지 버튼을 누르세요.',
  RULES_DESC_25: '다음 상황에서는 자동 플레이 기능이 자동으로 비활성화됩니다:',
  RULES_DESC_26: '선택한 자동 플레이 라운드 수가 거의 다 되었을 때 화면에 알림 메시지가 표시됩니다.',
  RULES_DESC_27: '잔액 부족으로 인해 자동 플레이를 계속할 수 없습니다.',
  RULES_DESC_28: '잔액 변동 또는 단일 당첨 금액이 설정한 값을 초과하면 자동 플레이 중지 조건 중 하나 이상이 발생합니다.',
  RETURN_PLAYER: '플레이어 환수율',
  RULES_DESC_29: 'Hubert Hits 게임의 최적 이론적 플레이어 환수율은 99%입니다.',
  LAST_RESULT: '최근 결과',
  RULES_DESC_30: '최근 몇 라운드의 Crash 배당률은 베팅 탭(모바일)이나 게임 플레이 중에 확인할 수 있습니다. 햄버거 메뉴에서 리더보드를 볼 수 있습니다.',
  NAVIGATION_CONTROL: '탐색 컨트롤',
  RULES_DESC_34: '음소거를 하려면 볼륨 조절 버튼을 클릭하거나 탭하세요. 다시 한 번 클릭하거나 탭하면 음소거가 해제됩니다.',
  RULES_DESC_35: '햄버거 메뉴를 클릭하거나 탭하여 "내 베팅 기록"을 확인하세요. 기본적으로 오늘 세션이 먼저 표시됩니다. 특정 라운드의 세부 정보를 보려면 목록에서 선택하세요. 각 기록에는 날짜, 베팅 금액, 배당률, 캐시아웃 금액이 표시됩니다.',
  RULES_DESC_36: '전체 화면 모드를 시작하려면 전체 화면 버튼을 클릭하거나 탭하세요. 종료하려면 버튼을 다시 누르거나 키보드의 "Esc" 키를 누르세요.',
  GAME_CONVENIENCES: '게임 불편 사항',
  RULES_DESC_38: '기술적 오류 발생 시 게임이 종료됩니다. 유효한 캐시아웃 금액은 변함없이 유지되며, 미출금 금액은 환불됩니다. 시스템 또는 소프트웨어 오류로 라운드가 취소되면 모든 베팅 금액이 환불됩니다.',
  RULES_DESC_39: '잔액 또는 베팅과 관련해 문제가 있거나 문의 사항이 있으면 고객 지원에 연락해 주세요.',
  PINGOO_TITLE: 'Pingoo Splash',
  PINGOO_GAME_INFO: 'Pingoo Splash는 "Crash" 장르의 재미있는 온라인 멀티플레이어 게임입니다. 1.00x에서 시작하는 배당률이 충돌 전까지 무작위로 정해진 값까지 상승합니다. 충돌 전에 출금하면 해당 배당률이 곱해진 금액을 획득할 수 있습니다. 두려움 없는 모험가 Pingoo와 함께 위험한 비행을 하며 배고픈 범고래를 피하세요.',
  PINGOO_RULE_NAME_2: '베팅 기간이 종료된 후 게임에 참여했거나 현재 라운드에서 베팅을 하지 않은 경우, "다음 라운드 대기 중" 메시지가 표시됩니다. 관전자로서 현재 라운드를 지켜보면서 다음 라운드에 베팅할 수 있습니다.',
  PINGOO_RULE_NAME_3: '베팅이 승인되면 현재 게임 라운드에 참여하게 됩니다. 캐시아웃하려면 ‘캐시아웃’ 버튼을 클릭하거나 탭하세요.',
  PINGOO_RULE_NAME_4: '{{gameName}}는 실시간 게임이므로 인터넷 연결 상태에 따라 ‘캐시아웃’ 처리에 시간이 걸릴 수 있습니다.',
  PINGOO_RULE_NAME_5: '자동 플레이가 작동하는 동안 각 게임 라운드마다 베팅이 자동으로 확정됩니다. 자동 캐시아웃 설정이나 베팅 금액을 변경하려면 베팅을 취소해야 합니다',
  PINGOO_RULE_NAME_6: '{{gameName}} 게임의 최적 이론적 플레이어 환수율은 99%입니다.',
  NETWORK_ERROR: '현재 오프라인 상태입니다. 인터넷 연결을 확인해 주세요.',
  PLAY: '놀다',
  START: '시작',
  AUTO: '오토',
  GEMX_TITLE: 'Gem X',
  GEMX_GAME_INFO: 'GemX는 ‘크래시’ 장르의 짜릿한 온라인 멀티플레이어 게임입니다. 게임은 멀티플라이어가 1.00배로 시작되며, 멀티플라이어는 계속 상승하다가 무작위로 정해진 값에 도달한 후 급락합니다. 플레이어는 크래시가 발생하기 전에 현금화해야만 현재 멀티플라이어에 곱해진 배당금을 확보할 수 있습니다. GemX는 끊임없이 상승하는 멀티플라이어를 쫓으며 플레이어들이 자신의 운과 타이밍을 시험해 볼 수 있도록 초대합니다. 투자 기간이 길어질수록 위험은 커지지만, 얻을 수 있는 수익도 그만큼 커집니다.',
  BET_CLOSED: '베팅 마감',
  ACCEPT_BETS: '베팅 접수 중',
  WIRE_GAME_INFO: '시간은 흘러가고 전 세계가 지켜보고 있습니다. 이 박진감 넘치는 카지노 미니 게임에서, 회원님은 거액의 상금과 완전한 실패 사이에서 결정적인 역할을 하는 전문가입니다. 자르는 전선 하나하나가 승리를 배가시킵니다. 더 깊이 들어갈수록 판돈은 더 커집니다. 만약 감전선이 닿더라도 너무 걱정하지 마세요. 진정한 강자는 폭발을 쳐다보지 않습니다. 그저 옷에 묻은 먼지를 털고, 탄약을 장전한 뒤 다시 전장으로 향할 뿐입니다.',
  WIRE_GAME_INFO_1: '네 가지 난이도 단계에서 회원님의 담력을 시험해 보세요. 전술 전문가용 ‘쉬움’(12개 선), 빠른 멀티플라이어 상승을 노리는 이들을 위한 ‘중급’(6개 선)과 ‘어려움’(4개 선), 그리고 극한의 50/50 도전을 즐기는 이들을 위한 ‘하드코어’(2개 선)가 준비되어 있습니다. 전선이 적을수록 잡아낼 확률이 커집니다. 무덤덤하게 대처하든, 모든 것을 걸든, 다음 한 수야말로 모든 것을 뒤바꿀 수 있는 결정적인 순간이 될 수 있습니다.',
  WIRE_HOW_TO_PLAY_DESC_1: '위험을 선택하세요. 네 가지 레벨 중에서 선택하세요. 쉬움(12개), 보통(6개), 어려움(4개), 또는 50/50 하드코어(2개)가 준비되어 있습니다.',
  WIRE_HOW_TO_PLAY_DESC_2: '판돈을 설정하세요. 베팅 금액을 선택하세요. 판돈 금액이 높을수록, 각 라운드마다 얻을 수 있는 잠재적 배당금도 커집니다.',
  WIRE_HOW_TO_PLAY_DESC_3: '판돈을 설정하세요. 베팅 금액을 입력하세요. 판돈 금액이 높을수록, 각 라운드마다 얻을 수 있는 잠재적 배당금도 커집니다.',
  WIRE_HOW_TO_PLAY_DESC_4: '자르세요. 해체할 전선을 직접 클릭하거나, “무작위 절단” 버튼을 눌러 시스템이 전선을 선택하도록 하세요.',
  WIRE_HOW_TO_PLAY_DESC_5: '올인하세요. “모두 해체” 버튼을 사용하면 전선을 하나만 남기고 나머지는 무작위로 끊어, 최고의 고속 멀티플라이어를 얻을 수 있습니다.',
  WIRE_HOW_TO_PLAY_DESC_6: '현금화하거나 계속하세요. 원할 때 언제든지 상금을 인출하거나, 계속해서 도전하여 최종 잭팟을 노려보세요.',
  WIRE_HOW_TO_PLAY_DESC_7: '퓨즈를 확인하세요. “위험 전선”을 건드리면 라운드가 종료됩니다. 걱정 마세요. 페이지를 새로 고치고 다시 시도해 보세요.',
  WIRE_RULES_1: '안전한 전선을 하나씩 끊을 때마다 멀티플라이어가 증가합니다. 폭탄의 해체 작업이 완료되면, 멀티플라이어를 더욱 높일 수 있도록 다음 장치로 넘어갈 수 있습니다. 현재 멀티플라이어 값은 폭발 장치의 중앙과 멀티플라이어 바에 표시되며, 멀티플라이어 바에는 현재 배당금과 다음 배당금 예상치가 모두 표시됩니다.',
  WIRE_RULES_2: '“-/+” 버튼을 사용하거나, 미리 설정된 금액을 선택하거나, 원하는 금액을 직접 입력하여 베팅 금액을 조정하세요. 베팅 금액을 설정한 후, ‘베팅’ 버튼을 눌러 베팅을 확정하고, 멀티플라이어를 높이기 위해 전선을 자르기 시작하세요.',
  BALANCE_INDICATOR: '잔액 표시기',
  WIRE_RULES_3: '잔액 표시기에 사용 가능한 자금과 통화가 표시됩니다. 시작하기 전에 베팅 금액을 충당할 수 있을 만큼 잔액이 충분한지 확인하세요. 베팅, 승리 또는 패배 후 잔액이 즉시 업데이트되지 않으면 게임을 다시 시작해 주세요.',
  CASHING_OUT: '캐시아웃',
  WIRE_RULES_4: '폭탄이 완전히 해체되기 전에 상금을 확보하려면 캐시아웃 버튼을 클릭하거나 탭하세요. The Wire는 실시간 게임이므로, 인터넷 연결 상태에 따라 캐시아웃 처리에 약간의 지연이 발생할 수 있음을 유의해 주시기 바랍니다.',
  AUTO_PLAY_RANDOM: '자동 플레이: 무작위 옵션',
  WIRE_RULES_5: '베팅이 완료되면, 특수 기능을 활용하여 처리 속도를 높일 수 있습니다:',
  CUT_RANDOM_1: '무작위 절단 1: ',
  CUT_RANDOM_2: '1개를 제외한 모든 절단: ',
  WIRE_RULES_6: '이 기능은 무작위 전선 하나를 선택하여 절단합니다. 폭탄이 해체되거나 잘못된 전선이 작동할 때까지 여러 번 사용할 수 있습니다.',
  WIRE_RULES_7: '이 고위험 기능의 사용을 확인하라는 팝업 창이 표시됩니다. 동일한 세션 내에서 향후 라운드에서는 이 경고를 숨기도록 선택할 수 있습니다.',
  WIRE_INFORMATION_AND_RESULTS: '게임 정보 및 결과',
  WIRE_INFO_HEAD_1: '플레이어 환수율(RTP): ',
  WIRE_INFO_HEAD_2: '최근 결과: ',
  WIRE_INFO_HEAD_3: '탐색: ',
  WIRE_INFO_DESC_1: ' The Wire의 최적 이론적 플레이어 환수율은 XX%입니다.',
  WIRE_INFO_DESC_2: '최근 라운드의 멀티플라이어 값은 라운드 기록 탭에 표시됩니다.',
  WIRE_INFO_DESC_3: '볼륨 아이콘을 눌러 소리를 켜거나 끄고, 메뉴(햄버거) 아이콘을 눌러 베팅 내역을 확인하며, 전체 화면 버튼을 눌러 화면을 확대할 수 있습니다.',
  TECHNICAL_ISSUES: '기술적 문제',
  WIRE_RULES_8: '기술적 오류가 발생할 경우, 게임이 종료됩니다. 유효한 모든 캐시아웃은 그대로 유지되며, 미출금 금액과 취소된 라운드에 걸린 베팅 금액은 환불됩니다. 잔액이나 베팅과 관련하여 문제가 발생하면 고객 지원팀에 문의해 주세요.',
  CASHOUT: '캐시아웃',
  WIRE_NAME: 'The Wire: 위험천만한 해체 작전',
  WINNING_AMOUNT: '승리 금액',
  DIFFICULTY: '난이도',
  YOU_CASH_OUT: '출금이 완료되었습니다!',
  CASH_WIN: '당첨금',
  WIRE_SKIP: '클릭하여 건너뛰기',
  WIRE_BET_WARNING: '먼저\n\n\n베팅을\n\n\n하세요',
  WIRE_LEVEL_1: '쉬움',
  WIRE_LEVEL_2: '보통',
  WIRE_LEVEL_3: '어려움',
  WIRE_LEVEL_4: '하드코어',
  WIRE_LEVEL_OK: '확인',
  WIRE_LEVEL_DES1: '폭탄을 해체하려면 안전한 전선만 잘라내세요.\n안전하게 잘라낼 때마다 멀티플라이어가 올라갑니다.\n“위험” 전선을 건드리면 즉시\n폭발이 일어납니다.\n\n',
  WIRE_LEVEL_DES2: '\n\n월급과 파산 사이에는 단 한 가닥의 전선만\n걸려 있습니다. 수표를 쥐고 있는 사람이 되도록\n노력해 보세요.',
  WIRE_LEVEL_EASY: '아마추어 전선: 총 12개의 전선 중\n1개가 “위험”입니다.',
  WIRE_LEVEL_MEDIUM: '표준화된 점화 배열: 5개는 중립이고,\n1개가 발동합니다.',
  WIRE_LEVEL_HARD: '임계 밀도 설정: 3개는 안전하고,\n1개는 위험합니다.',
  WIRE_LEVEL_HARDCORE: '이진 “데드맨” 스위치.\n50%의 치사율.',
  WIRE_LOOSE_LEVEL: '레벨',
  WIRE_TRY_AGAIN: '다시 시도',
  WIRE_CONTINUE: '계속하기',
  WIRE_CASHOUT: '캐시아웃',
  WIRE_WIN_DES1: '획득:',
  WIRE_WIN_DES2: '다음 승리',
  WIRE_CUT_ALL: '예, 모두 절단',
  WIRE_CUT_ALL_DES: '모든 전선을 절단할까요? 취소할 수 없습니다.',
  WIRE_SHOW_AGAIN: '다시 표시하지 않음',
  WIRE_CANCEL: '취소',
  WIRE_WARNING: '경고!',
  WIRE_NETWORK_ERROR: '네트워크 오류',
  WIRE_NETWORK_ERROR_DES: '인터넷 연결을 확인하고\n다시 시도하세요.',
  WIRE_LOST: '패배',
  WIRE_BOMB_DEFUSE: '폭탄 해체됨',
  WIRE_DEFUSE: '해체됨',
  WIRE_WELL_DONE: '잘하셨어요!',
  WIRE_SOUND: '폭탄 폭발 소리',
  MODE: '모드',
  CHANGE_MODE: '게임 모드 변경',
  WIRE_MAX_MULTIPLIER: '{{ multiplier }}x 최대 배수에 도달했습니다. 당첨금이 자동으로 출금되었습니다!',
  INTERNAL_ERROR: '내부 서버 오류',
  SESSION_EXPIRED: '세션이 만료되었습니다. 계속 베팅하려면 새로고침하세요',
  INSUFFICIENT_FUNDS: '잔액 부족'
}

export default {
  ...translationKeys
}
